
import { useCallback } from "react";

const API = process.env.REACT_APP_API_URL;

export function useScenarioTracker({ code }) {
  const unlockScenarioStep = useCallback(
    async (keyOrKeys) => {
      if (!keyOrKeys || !code) return;

      try {
        // ⬇️ Supporte à la fois string et array
        const body = Array.isArray(keyOrKeys)
          ? { keys: keyOrKeys }
          : { key: keyOrKeys };

        await fetch(`${API}/api/sessions/${code}/scenario-tracker/unlock`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        });
      } catch (error) {
        console.error("Unlock scenario step error:", error);
      }
    },
    [code]
  );

  return { unlockScenarioStep };
}